import React from 'react';
import './styles.scss';

type ProgressBarProps = {
  visits: number;
  goal1: number;
  goal2: number;
  type: 'user' | 'team';
};

const Scoreboard: React.FC<ProgressBarProps> = ({
  visits,
  goal1,
  goal2,
  type,
}) => {
  const formatNumber = (num: number, minDigits: number = 2): string => {
    return num.toString().padStart(minDigits, '0');
  };

  const getCurrentGoal = (): number => {
    if (visits < goal1) {
      return goal1;
    } else if (visits >= goal1 && visits < goal2) {
      return goal2;
    } else {
      return goal2;
    }
  };

  const currentGoal = getCurrentGoal();

  return (
    <div className="scoreboard">
      <div className={`scoreboard__container scoreboard__container--${type}`}>
        {/* Контейнеры для областей цифр */}
        <div className="scoreboard__digit-area scoreboard__digit-area--sessions">
          <div className="scoreboard__number scoreboard__number--sessions">
            {formatNumber(visits)}
          </div>
        </div>

        <div className="scoreboard__digit-area scoreboard__digit-area--goal">
          <div className="scoreboard__number scoreboard__number--goal">
            {formatNumber(currentGoal)}
          </div>
        </div>

        <div className="scoreboard__digit-area scoreboard__digit-area--bracket1">
          <div className="scoreboard__number scoreboard__number--bracket1">
            {formatNumber(goal1)}
          </div>
        </div>

        <div className="scoreboard__digit-area scoreboard__digit-area--bracket2">
          <div className="scoreboard__number scoreboard__number--bracket2">
            {formatNumber(goal2)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Scoreboard;
